// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2vUnI","head":"ProcedureTableInfo_head__2eMNC"};